/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var TicketsIcon = createIcon("TicketsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12A3.5 3.5 0 0124 8.5V5a2 2 0 00-2-2H2a2 2 0 00-2 2v3.5a3.5 3.5 0 010 7V19a2 2 0 002 2h20a2 2 0 002-2v-3.5a3.5 3.5 0 01-3.5-3.5Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: "5",
    y: "4",
    width: "1",
    height: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: "5",
    y: "7",
    width: "1",
    height: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: "5",
    y: "10",
    width: "1",
    height: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: "5",
    y: "13",
    width: "1",
    height: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: "5",
    y: "16",
    width: "1",
    height: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: "5",
    y: "19",
    width: "1",
    height: "1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#666",
    x: "8",
    y: "9",
    width: "10",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#666",
    x: "8",
    y: "15",
    width: "10",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#666",
    x: "8",
    y: "12",
    width: "10",
    height: "1"
  })));
}, {});